import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {AggregateStore} from 'js/stores'; // singleton stores
import styles from 'css/screens/result.css';
import Materialization from './materialization';
import Analysis from './analysis';
import CallOut from './call-out';
import Development from './development';

@observer
/**
 * Phase
 */
export default class Advice extends Component {
  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    let advice = null;
    switch (AggregateStore.adviceType) {
    case 1:
      advice = (<Analysis />);
      break;
    case 2:
      advice = (<Development />);
      break;
    case 3:
      advice = (<Materialization />);
      break;
    case 4:
      advice = (<CallOut />);
      break;
    }

    return (
      <div className={styles.block}>
        {advice}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/screens/result/advice/index.js